{
	"title": "Δημιουργία δήλωσης",
	"backLinkToMaterialDetailsTitle": "Επιστροφή στις Λεπτομέρειες Υλικού",
	"backLinkToMaterialDetailsWithDescriptionTitle": "Επιστροφή στο {{materialDescription}}",
	"backLinkToManageDeclarationsTitle": "Επιστροφή στη Διαχείριση δηλώσεων",
	"steps": {
		"firstStep": {
			"title": "Βήμα 1",
			"label": "1"
		},
		"secondStep": {
			"title": "Βήμα 2",
			"label": "2"
		},
		"thirdStep": {
			"title": "Βήμα 3",
			"label": "3"
		}
	}
}
